// Parámetros de negocio. Es el único lugar donde se tocan: la API los usa para
// validar y el front para mostrar y validar mientras se escribe. Los que también
// controla la base (tope de turnos, ventana de reserva) están en la migración
// 0002 con el mismo valor.
/** Cancelando con al menos esta anticipación se devuelve la seña. */
export const HORAS_PARA_CANCELAR_SIN_CARGO = 24;
/** Turnos pendientes o confirmados a futuro que puede tener un paciente. */
export const MAXIMO_TURNOS_FUTUROS = 5;
/** Hasta cuántos días adelante se puede reservar. */
export const DIAS_MAXIMOS_DE_ANTICIPACION = 60;
/** Grilla de la agenda: cada cuántos minutos arranca un turno posible. */
export const PASO_DE_AGENDA_MINUTOS = 30;
export const RESENA_MINIMO_CARACTERES = 20;
export const RESENA_MAXIMO_CARACTERES = 500;
/** Sugerencia al configurar la seña: el monto final lo define cada profesional. */
export const PORCENTAJE_SENA_SUGERIDO = 0.3;
/** El plan anual cobra diez meses y regala dos. */
export const MESES_COBRADOS_EN_PLAN_ANUAL = 10;
/** El plan Básico admite esta cantidad de turnos por mes. */
export const TURNOS_POR_MES_PLAN_BASICO = 10;
/** La plataforma es para mayores de edad. El máximo solo descarta fechas mal cargadas. */
export const EDAD_MINIMA = 18;
export const EDAD_MAXIMA = 110;
/** Edad cumplida a una fecha, las dos en 'AAAA-MM-DD'. */
export function edadEn(nacimiento, hoy) {
    return Number(hoy.slice(0, 4)) - Number(nacimiento.slice(0, 4)) - (hoy.slice(5) < nacimiento.slice(5) ? 1 : 0);
}
/** Meta del plan de negocios: qué parte de los profesionales pasa a un plan pago, sobre cuántos. */
export const CONVERSION_A_PLAN_PAGO_PROYECTADA = 0.15;
export const PROFESIONALES_PROYECTADOS = 400;
